export const assetionOrSilentNull = <T>(asserter: (x: unknown) => T) => (x: unknown): T | null => {
  try {
    return asserter(x)
  } catch {
    return null
  }
}
